import { render, staticRenderFns } from "./ItemDisplay.vue?vue&type=template&id=45dce595"
import script from "./ItemDisplay.vue?vue&type=script&lang=js"
export * from "./ItemDisplay.vue?vue&type=script&lang=js"
import style0 from "./ItemDisplay.vue?vue&type=style&index=0&id=45dce595&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports